const format = [{value: "Excel", data:"Excel"}, {value: "Pdf", data: "Pdf"}];

export default format;